import { createContext, useContext } from 'react';
import * as trackingEvents from "./trackingEvents";
export var TrackingContext = /*#__PURE__*/createContext(undefined);
export var useTracking = function useTracking() {
  var context = useContext(TrackingContext);
  if (context === undefined) {
    throw new Error('useTracking must be used within a TrackingContextProvider');
  }
  var navigationData = context.navigationData;
  return {
    onClickLink: function onClickLink(evt, item) {
      trackingEvents.clickLink(evt, navigationData, item);
    },
    onHoverLink: function onHoverLink(index, item) {
      trackingEvents.hoverLink(index, item);
    }
  };
};